import { createTheme } from "@mui/material/styles";

const theme2 = createTheme({
  breakpoints: {
    values: {
      md: 1280,
      lg: 1535,
      xl: 1537,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
          padding: "8px 16px",
        },
        contained: {
          backgroundColor: "#6C65D9",
          color: "#fff",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "#554BB8",
          },
        },
        outlined: {
          borderColor: "#6C65D9",
          color: "#6C65D9",
          "&:hover": {
            borderColor: "#554BB8",
            backgroundColor: "rgba(108, 101, 217, 0.1)",
          },
        },
        /* text: {
          color: "#6C65D9",
          "&:hover": {
            backgroundColor: "rgba(108, 101, 217, 0.1)",
          },
        }, */
      },
    },
  },
});

export default theme2;
